import request from "../utils/request.js";
import qs from "qs";

export function getUserList(queryParams) {
  return request({
    url: `/users/list`,
    method: 'GET',
    params: queryParams,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}

export function getEndUserList(queryParams) {
  return request({
    url: `/users/endUsersList`,
    method: 'GET',
    params: queryParams,
    // paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}

export function updateUserRole(queryParams) {
  return request({
    url: `/users/updateRole`,
    method: 'POST',
    data: queryParams
  });
}
export function updateSystemUser(queryParams) {
  return request({
    url: `/users/updateSystemUser`,
    method: 'POST',
    data: queryParams
  });
}

export function getUserLog({ pageNum, pageSize, tabFlag, companyId }) {
  return request({
    url: `/users/log`,
    method: 'GET',
    params: { pageNum, pageSize, tabFlag, companyId }
  });
}

export function getRoleLog({ pageNum, pageSize }) {
  return request({
    url: `/roles/log`,
    method: 'GET',
    params: { pageNum, pageSize }
  });
}

export function updateSysUser(queryParams) {
  return request({
    url: `/users/updateSysUser`,
    method: 'POST',
    data: queryParams
  });
}

export function createUser(user) {
  return request({
    url: `/users/createUser`,
    method: 'POST',
    data: user
  });
}
export function createCompanyUser(user) {
  return request({
    url: `/users/createCompanyUser`,
    method: 'POST',
    data: user
  });
}
export function getRoleList() {
  return request({
    url: `/roles/list`,
    method: 'GET',
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}

export function saveRoleList(queryParams) {
  return request({
    url: `/roles/save`,
    method: 'POST',
    data: queryParams
  });
}

export function getCompanyList() {
  return request({
    url: `/roles/companyList`,
    method: 'GET',
  });
}



export function saveCompanyList(queryParams) {
  return request({
    url: `/roles/saveCompanyList`,
    method: 'POST',
    data: queryParams
  });
}

export function deleteCompanyUser(queryParams) {
  return request({
    url: `/users/deleteCompanyUser`,
    method: 'POST',
    data: queryParams
  });
}
